import { makeStyles } from '@material-ui/core';

const TABLE_HEADER_BACKGROUND = '#EEF3FF';

const useStyles = makeStyles(theme => ({
  pageHelp: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  toolbarSection: {
    marginBottom: theme.spacing(2),
  },
  headerActions: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  createButton: {
    alignItems: 'center',
    display: 'inline-flex',
    gap: theme.spacing(1),
  },
  filtersRow: {
    alignItems: 'flex-end',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  searchRow: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    minWidth: 0,
  },
  searchInputCell: {
    flex: '1 1 0',
    minWidth: 0,
    overflow: 'hidden',
  },
  filterSelect: {
    minWidth: 180,
  },
  metricsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  metricTile: {
    flex: '1 1 0',
    minWidth: 0,
  },
  metricCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    padding: theme.spacing(2),
  },
  metricLabel: {
    fontWeight: 500,
  },
  metricValueLine: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  metricValue: {
    fontWeight: 600,
    lineHeight: 1.1,
  },
  metricHint: {
    display: 'block',
    marginTop: theme.spacing(0.5),
  },
  tableScrollWrapper: {
    overflowX: 'auto',
    width: '100%',
    WebkitOverflowScrolling: 'touch',
    '& > div': {
      minWidth: 'max-content',
      overflow: 'visible',
    },
    '& table': {
      tableLayout: 'auto',
      width: '100%',
    },
    '& thead th': {
      whiteSpace: 'nowrap',
    },
    // Override Table's td z-index:-1 so row clicks are not lost under the sticky actions column.
    '& table tbody td': {
      position: 'relative',
      zIndex: 1,
    },
    '& table th:nth-last-child(1), & table td:nth-last-child(1)': {
      boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.06)',
      minWidth: 56,
      padding: theme.spacing(1, 0.5),
      position: 'sticky',
      right: 0,
      verticalAlign: 'middle',
      zIndex: 2,
    },
    '& table thead th:nth-last-child(1)': {
      background: TABLE_HEADER_BACKGROUND,
      borderTopRightRadius: 8,
      boxShadow: '-4px 0 8px rgba(16, 24, 40, 0.06)',
      zIndex: 3,
    },
    '& table tbody td:nth-last-child(1)': {
      background: theme.palette.common.white,
      zIndex: 2,
      '&::before': {
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.06), transparent)',
        bottom: 0,
        content: '""',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: 8,
        zIndex: 0,
      },
      '& > span': {
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 1,
      },
    },
  },
  nameCell: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  draftBadge: {
    backgroundColor: '#fff4e5',
    color: '#9a6700',
    fontWeight: 600,
  },
  legalBasisCell: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  legalBasisChip: {
    maxWidth: 140,
  },
  overflowChip: {
    backgroundColor: theme.palette.grey[200],
  },
  priorityLabel: {
    alignItems: 'center',
    display: 'inline-flex',
    fontWeight: 600,
    gap: theme.spacing(0.75),
    '&::before': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: '50%',
      content: '""',
      display: 'inline-block',
      height: 8,
      width: 8,
    },
  },
  priorityNormal: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
  priorityElevated: {
    '&::before': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  priorityHigh: {
    '&::before': {
      backgroundColor: theme.palette.error.main,
    },
  },
  statusCell: {
    alignItems: 'center',
    display: 'inline-flex',
    gap: theme.spacing(0.75),
  },
  statusDot: {
    borderRadius: '50%',
    display: 'inline-block',
    height: 8,
    width: 8,
  },
  statusDotPublished: {
    backgroundColor: theme.palette.success.main,
  },
  statusDotArchived: {
    backgroundColor: theme.palette.grey[500],
  },
  actionsCell: {
    display: 'flex',
    justifyContent: 'center',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  emptyState: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  forbiddenState: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  forbiddenBackButton: {
    marginTop: theme.spacing(2),
  },
  errorBanner: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
}));

export default useStyles;
